import './splash.css';

/**
 * Arcade stílusú indítóképernyő: logó, villogó „NYOMJ STARTOT", mozgó fénycsíkok.
 * Kattintásra/billentyűre (vagy 6 mp után) eltűnik, és elindul a menü.
 */
export function showSplash(root: HTMLElement): Promise<void> {
  const el = document.createElement('div');
  el.className = 'splash';
  el.setAttribute('role', 'presentation');

  const bg = document.createElement('div');
  bg.className = 'splash__bg';
  bg.setAttribute('aria-hidden', 'true');
  const road = document.createElement('div');
  road.className = 'splash__road';
  bg.append(road);

  const inner = document.createElement('div');
  inner.className = 'splash__inner';

  const kicker = document.createElement('div');
  kicker.className = 'splash__kicker';
  kicker.textContent = 'CSÚCSFORGALOM KUPA';

  const logo = document.createElement('h1');
  logo.className = 'splash__logo';
  const top = document.createElement('span');
  top.textContent = 'SOMA';
  const bottom = document.createElement('span');
  bottom.className = 'splash__logo-bottom';
  bottom.textContent = 'KART';
  logo.append(top, bottom);

  const sub = document.createElement('div');
  sub.className = 'splash__sub';
  sub.textContent = 'VÁROSI KART VERSENY · 1–4 JÁTÉKOS';

  const press = document.createElement('div');
  press.className = 'splash__press';
  press.textContent = 'START';

  const foot = document.createElement('div');
  foot.className = 'splash__foot';
  foot.textContent = '© 2026 · BILLENTYŰZET / GAMEPAD';

  inner.append(kicker, logo, sub, press, foot);

  const scan = document.createElement('div');
  scan.className = 'splash__scan';
  scan.setAttribute('aria-hidden', 'true');

  el.append(bg, inner, scan);
  root.appendChild(el);

  return new Promise((resolve) => {
    let done = false;
    let armed = false;
    const armTimer = window.setTimeout(() => {
      armed = true;
      press.classList.add('is-ready');
    }, 650);

    const cleanup = (): void => {
      window.removeEventListener('keydown', onKey, true);
      window.removeEventListener('pointerdown', onPointer, true);
      window.clearTimeout(armTimer);
      window.clearTimeout(autoTimer);
    };

    const finish = (): void => {
      if (done) return;
      done = true;
      cleanup();
      el.classList.add('splash--out');
      window.setTimeout(() => {
        el.remove();
        resolve();
      }, 380);
    };

    const onKey = (event: KeyboardEvent): void => {
      if (!armed) return;
      event.preventDefault();
      event.stopPropagation();
      finish();
    };

    const onPointer = (event: PointerEvent): void => {
      if (!armed) return;
      event.preventDefault();
      event.stopPropagation();
      finish();
    };

    window.addEventListener('keydown', onKey, true);
    window.addEventListener('pointerdown', onPointer, true);
    const autoTimer = window.setTimeout(finish, 6000);
  });
}
